<template>
    <div class="authentication-editor">
        <label>{{ $t('whatsapp_business_api.authSettings') }}</label>
        
        <div class="auth-setting-row">
            <a-checkbox :checked="data.addSecurityRecommendation" @change="updateSecurity">
                {{ $t('whatsapp_business_api.addSecurityRecommendation') }}
            </a-checkbox>
            <span class="hint-text">
                {{ $t('whatsapp_business_api.securityRecommendationHint') }}
            </span>
        </div>

        <div class="auth-setting-row" style="margin-top: 16px;">
            <label>{{ $t('whatsapp_business_api.messageTtlSecondsOptional') }}</label>
            <a-input-number
                :value="data.messageSendTtlSeconds"
                @change="updateTtl"
                :min="60"
                :max="600"
                :placeholder="$t('whatsapp_business_api.authTtlPlaceholder')"
                style="width: 100%"
            />
            <span class="hint-text">
                {{ $t('whatsapp_business_api.authMessageTtlHint') }}
            </span>
        </div>

        <div class="auth-setting-row" style="margin-top: 16px;">
            <label>{{ $t('whatsapp_business_api.codeExpirationOptional') }}</label>
            <a-input-number
                :value="data.codeExpirationMinutes"
                @change="updateExpiration"
                :min="1"
                :max="90"
                :placeholder="$t('whatsapp_business_api.authCodeExpPlaceholder')"
                style="width: 100%"
            />
            <span class="hint-text">
                {{ $t('whatsapp_business_api.codeExpirationHint') }}
            </span>
        </div>

        <!-- Zero Tap Terms -->
        <div v-if="data.otpSubType === 'ZERO_TAP'" class="auth-setting-row" style="margin-top: 16px; padding-top: 16px; border-top: 1px solid #e8e8e8;">
            <a-checkbox :checked="data.zeroTapTermsAccepted" @change="updateTerms">
                {{ $t('whatsapp_business_api.zeroTapTerms') }}
            </a-checkbox>
            <span class="hint-text">
                {{ $t('whatsapp_business_api.zeroTapTermsHint') }}
            </span>
        </div>

        <!-- Supported Apps -->
        <div v-if="data.otpSubType !== 'COPY_CODE'" class="auth-setting-row" style="margin-top: 16px;">
            <label>{{ $t('whatsapp_business_api.supportedAndroidAppsOptional') }}</label>
            <div v-for="(app, index) in data.supportedApps" :key="index" class="supported-app-row">
                <a-input
                    :value="app.packageName"
                    @input="updateAppPackage(index, $event.target.value)"
                    :placeholder="$t('whatsapp_business_api.authPackagePlaceholder')"
                    style="flex: 1"
                />
                <a-input
                    :value="app.signatureHash"
                    @input="updateAppSignature(index, $event.target.value)"
                    :placeholder="$t('whatsapp_business_api.authSignatureHash')"
                    style="flex: 1"
                />
                <a-button type="link" @click="removeApp(index)">
                    <a-icon type="delete" />
                </a-button>
            </div>
            <a-button size="small" @click="addApp" style="margin-top: 8px;">
                <a-icon type="plus" /> {{ $t('whatsapp_business_api.addApp') }}
            </a-button>
        </div>
    </div>
</template>

<script>
import Vue from "vue";

export default Vue.extend({
    name: "AuthenticationEditor",
    props: {
        data: { type: Object, required: true },
    },
    methods: {
        updateSecurity(e) {
            this.$emit('update', { ...this.data, addSecurityRecommendation: e.target.checked });
        },
        updateTtl(value) {
            this.$emit('update', { ...this.data, messageSendTtlSeconds: value });
        },
        updateExpiration(value) {
            this.$emit('update', { ...this.data, codeExpirationMinutes: value });
        },
        updateTerms(e) {
            this.$emit('update', { ...this.data, zeroTapTermsAccepted: e.target.checked });
        },
        updateAppPackage(index, value) {
            const apps = [...this.data.supportedApps];
            apps[index].packageName = value;
            this.$emit('update', { ...this.data, supportedApps: apps });
        },
        updateAppSignature(index, value) {
            const apps = [...this.data.supportedApps];
            apps[index].signatureHash = value;
            this.$emit('update', { ...this.data, supportedApps: apps });
        },
        addApp() {
            const apps = [...this.data.supportedApps, { packageName: '', signatureHash: '' }];
            this.$emit('update', { ...this.data, supportedApps: apps });
        },
        removeApp(index) {
            const apps = [...this.data.supportedApps];
            apps.splice(index, 1);
            this.$emit('update', { ...this.data, supportedApps: apps });
        },
    },
});
</script>

<style scoped lang="scss">
.authentication-editor {
    background: #f0f5ff;
    border: 1px solid #adc6ff;
    border-radius: 8px;
    padding: 16px;

    label {
        display: block;
        margin-bottom: 4px;
        font-size: 13px;
        font-weight: 500;
    }

    .auth-setting-row {
        margin-bottom: 12px;

        &:last-child {
            margin-bottom: 0;
        }

        .hint-text {
            display: block;
            margin-top: 4px;
            font-size: 12px;
            color: #666;
            line-height: 1.5;
        }

        .ant-checkbox-wrapper {
            display: flex;
            align-items: flex-start;
        }

        .supported-app-row {
            display: flex;
            gap: 8px;
            margin-bottom: 8px;
            align-items: center;
        }
    }
}
</style>
